module.exports = __webpack_public_path__ + "static/list-chevron-008a39bba0990aa197988b050ae7eae6.png";